import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import reportWebVitals from "./reportWebVitals";

import "./index.css";
import App from "./App";

// Suppress benign ResizeObserver notification (triggered by Quill + Puck sidebar)
window.addEventListener("error", (e) => {
  if (
    e.message ===
    "ResizeObserver loop completed with undelivered notifications."
  ) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

if (process.env.REACT_NODE_ENV === "LOCAL") {
  const axe = require("@axe-core/react");
  axe(React, ReactDOM, 1000);
}

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
